// views/auth/login.js  (AR)
//
// Este fichero tenía la estructura antigua (text1, text2...), que ya no usa
// ninguna pantalla: por eso el acceso en árabe caía entero al inglés. Se pasa a
// las claves actuales. El original queda en .respaldo-auth por si algo viejo
// lo estuviera leyendo.
export const login_i18n = {
  panelKicker: "WACHECKIN · 2026",
  panelCta: "اكتشف WACheckin",
  partnersLabel: "متصل مع",
  // بطاقات مشهد اللوحة.
  escena: {
    reservas: "الحجوزات",
    mensajes: "رسائل تلقائية",
    llaves: "مفاتيح رقمية",
    checkin: "تسجيل الوصول عبر الإنترنت",
    cobros: "مدفوعات تلقائية",
    autoridades: "السلطات والامتثال",
  },

  // الخطوة 2: الرمز الذي يصل بالبريد.
  verify: {
    title: "تحقق من بريدك",
    titleWhatsapp: "تحقق من واتساب",
    sending: "جارٍ الإرسال…",
    destinoWhatsapp: "سيصل إلى",
    destinoCorreo: "سيصل إلى",
    intro: "أرسلنا رمزًا من {largo} أرقام إلى",
    submit: "دخول",
    submitting: "جارٍ التحقق...",
    back: "استخدام حساب آخر",
    resendAsk: "لم يصلك الرمز؟",
    resend: "إعادة إرسال الرمز",
    resendWait: "إعادة الإرسال خلال {s} ث",
    resendDone: "أرسلنا لك رمزًا جديدًا.",
    expires: "ينتهي الرمز خلال {tiempo}",
    expired: "انتهت صلاحية الرمز. اطلب رمزًا جديدًا.",
    digitAria: "الرقم {n} من {total}",
    otroMetodo: "لم يصلك البريد؟",
    porWhatsapp: "استلمه عبر واتساب",
    preferesCorreo: "تفضّل البريد؟",
    porCorreo: "استلمه عبر البريد",
    introWhatsapp: "أرسلنا رمزًا من {largo} أرقام عبر واتساب إلى",
    enviadoWhatsapp: "أرسلنا لك الرمز عبر واتساب.",
  },
  langLabel: "اللغة",
  panelTitle: "كل أماكن إقامتك مؤتمتة بالذكاء الاصطناعي",
  panelDesc:
    "تسجيل الوصول والرسائل والمفاتيح والمدفوعات والسلطات. لوحة واحدة لكل شيء.",

  bannerAlt: "خلفية تسجيل الدخول",
  brandAlt: "WA Checkin",
  footerLogoAlt: "WA Checkin",
  togglePasswordAria: "إظهار أو إخفاء كلمة المرور",

  title: "أهلاً بعودتك!",
  infoTitle: "إذا كان لديك حساب، ادخل ببريدك الإلكتروني.",
  infoDesc: "وإذا لم يكن لديك حساب بعد، يمكنك التسجيل في الأسفل.",

  emailLabel: "البريد الإلكتروني",
  emailPlaceholder: "أدخل بريدك الإلكتروني",

  passwordLabel: "كلمة المرور",
  passwordPlaceholder: "أدخل كلمة المرور",

  forgot: "هل نسيت كلمة المرور؟",

  submit: "تسجيل الدخول",
  submitting: "جارٍ تسجيل الدخول...",

  noAccount: "ليس لديك حساب؟",
  signup: "سجّل الآن",

  terms: "الشروط",
  privacy: "سياسة الخصوصية",
  copyright: "© 2024–{anio} WA Checkin. جميع الحقوق محفوظة.",

  resetSuccess: "أرسلنا إليك بريدًا لاستعادة كلمة المرور.",

  errors: {
    default: "تعذّر تسجيل الدخول.",
    network: "خطأ في الاتصال. حاول مرة أخرى.",
  },

  resetPassword: {
    title: "استعادة كلمة المرور",
    infoTitle: "سنرسل إليك رابطًا بالبريد",
    infoDesc: "أدخل بريدك الإلكتروني وستصلك تعليمات إعادة تعيين كلمة المرور.",
    labels: { email: "البريد الإلكتروني" },
    placeholders: { email: "name@email.com" },
    hints: { email: "استخدم البريد الذي سجّلت به." },
    buttons: { send: "إرسال", sending: "جارٍ الإرسال..." },
    successTitle: "تم!",
    successDesc: "راجع بريدك الوارد (والرسائل غير المرغوبة).",
    aria: { close: "إغلاق" },
    toasts: {
      emailRequired: "أدخل بريدك الإلكتروني.",
      sent: "أرسلنا البريد بالتعليمات.",
      userNotFound: "المستخدم غير مسجّل.",
      networkError: "خطأ في الاتصال. حاول مرة أخرى.",
    },
  },
  common: { ok: "حسنًا", cancel: "إغلاق" },

  // Textos de antes del rediseño del login que siguen usando otras pantallas
  // (Reset.vue). No borrarlos aunque el login ya no los use.
  text1: "Log in to your account",
  text2: "Welcome to QrCheck-in!",
  text3: "Enter your Email",
  text4: "Password",
  text5: "Email",
  text6: "Enter your Password",
  text7: "Remember",
  text8: "Forgot your password?",
  text9: "Don't have an account?",
  text10: "Sign up",
  text11: "Start",
  text12: "Sign in with Google",
  text13: "Country",
  text14: "Error",
  text15: "Select a language",
  text16: "Registered successfully",
  p1: "Recover Password",
  p2: "I Forgot My Password",
  p3: "A recovery link will be sent via email",
  p4: "Email",
  p5: "Recover",
  p6: "Sent Successfully",
  p7: "Check Your Inbox",
  p8: "Email is Required",
  p9: "Recovery Email Sent!",
  p10: "Sign in to Your Account",
  p11: "Enter Your Email",
  p12: "Password",
  p13: "Set a Password",
  p14: "Continue",
};
